export default "assets/images/icons/arrow-742cbce1.svg";